import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function WhatsAppButton() {
  const [phone, setPhone] = useState("+90 536 814 7467");
  useEffect(() => {
    api.get("/settings/site").then((r) => {
      if (r.data?.phone) setPhone(r.data.phone);
    }).catch(() => {});
  }, []);

  const cleanNumber = phone.replace(/[^\d]/g, "");
  const href = `https://wa.me/${cleanNumber}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-50 group w-14 h-14 isolate"
    >
      {/* Pulse ring — contained inside the 56x56 box so it can't push the viewport horizontally */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 group-hover:opacity-50 animate-ping" aria-hidden style={{ transformOrigin: "center" }} />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] transition-all duration-300 hover:scale-110">
        <svg viewBox="0 0 32 32" fill="currentColor" className="w-7 h-7" aria-hidden>
          <path d="M19.11 17.36c-.27-.13-1.6-.79-1.85-.88s-.43-.13-.61.13c-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.15-1.32-.79-.71-1.32-1.58-1.48-1.85-.16-.27-.02-.41.12-.54.12-.12.27-.32.4-.48.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.46h-.52c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.26 0 1.34.97 2.62 1.11 2.81.13.18 1.92 2.93 4.66 4.11.65.28 1.16.45 1.56.58.66.21 1.26.18 1.73.11.53-.08 1.6-.65 1.82-1.28.23-.63.23-1.17.16-1.28-.07-.11-.25-.18-.52-.31zM16 4C9.38 4 4 9.38 4 16c0 2.11.55 4.18 1.59 6L4 28l6.18-1.62A11.95 11.95 0 0 0 16 28c6.62 0 12-5.38 12-12S22.62 4 16 4zm0 21.94c-1.83 0-3.62-.49-5.19-1.42l-.37-.22-3.66.96.98-3.57-.24-.37A9.93 9.93 0 0 1 6.06 16C6.06 10.51 10.51 6.06 16 6.06c2.66 0 5.16 1.04 7.04 2.92A9.92 9.92 0 0 1 25.94 16c0 5.49-4.45 9.94-9.94 9.94z" />
        </svg>
      </span>
    </a>
  );
}
